<template>
	<div class="boat-detail-section">
		<div class="boat__details">
			<div class="details__top">
				<div class="title">
					<div class="boat__name">
						<div class="boat__year leading-tight">
							<div class="text-orange-brand">{{ inventory.boat.model_year }}</div>
						</div>
						<h3>{{ inventory.boat.name }}</h3>
					</div>
					<div class="text-white mt-2 space-y-1 sm:mt-0 sm:text-right">
						<div class="text-white text-[12px] leading-none">MSRP</div>
						<div class="price">${{ inventory.msrp_price }}</div>
					</div>
				</div>
				<div class="content mt-[25px]">
					<div class="flex">
						<div>
							<div class="colors">
								<color-swatch :color="inventory?.exterior_color" label="Hull Color"></color-swatch>
								<color-swatch :color="inventory?.accent_color" label="Hull Accent Color"></color-swatch>
								<color-swatch :color="inventory?.upper_color" label="Upper Hull Color"></color-swatch>
								<color-swatch :color="inventory?.lower_color" label="Lower Hull Color"></color-swatch>
								<color-swatch :color="inventory?.interior_color" label="Interior Color"></color-swatch>
								<!--<color-swatch :color="inventory?.canvas_color" label="Canvas Color"></color-swatch>-->
							</div>
						</div>
					</div>
					<div class="text-sm text-white mt-3">
						Status: <span class="font-semibold">In-Stock</span>
					</div>
				</div>
				<div class="cta mt-[26px]">
					<a href="#" @click.prevent="visiting = true">Schedule Showroom Visit</a>
					<a href="#" @click.prevent="calling = true">Call Me About This Boat</a>
				</div>
			</div>
			<div class="details__bottom">
				<div class="address__title flex gap-[10px] items-center">
					<div class="icon">
						<svg class="text-gray-brand" width="19" height="27" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 9.5a9 9 0 0 1 9-9 9 9 0 0 1 9 9c0 1.268-.569 2.928-1.39 4.677-.827 1.758-1.927 3.641-3.023 5.368a94.99 94.99 0 0 1-4.36 6.269l-.026.032v.001l-.201-.154-.2.154-.007-.008-.02-.025a91.847 91.847 0 0 1-1.346-1.824 94.962 94.962 0 0 1-3.014-4.445c-1.096-1.727-2.196-3.61-3.022-5.368C1.069 12.428.5 10.768.5 9.5Zm9 16.193-.2.154.2.26.2-.26-.2-.154Zm0-.419.173-.23a94.454 94.454 0 0 0 3.987-5.77c1.09-1.718 2.178-3.581 2.991-5.312.818-1.74 1.343-3.313 1.343-4.462 0-4.69-3.8-8.494-8.494-8.494A8.493 8.493 0 0 0 1.006 9.5c0 1.149.525 2.721 1.343 4.462.813 1.73 1.9 3.594 2.991 5.311a94.485 94.485 0 0 0 4.16 6.002Zm0-19.752A3.98 3.98 0 0 0 5.522 9.5 3.98 3.98 0 0 0 9.5 13.478 3.98 3.98 0 0 0 13.478 9.5 3.98 3.98 0 0 0 9.5 5.522ZM5.016 9.5A4.485 4.485 0 0 1 9.5 5.016 4.485 4.485 0 0 1 13.984 9.5 4.485 4.485 0 0 1 9.5 13.984 4.485 4.485 0 0 1 5.016 9.5Z" fill="currentColor"/></svg>
					</div>
					<div class="text-white font-semibold">{{ location?.dealer?.name }}</div>
				</div>
				<div class="address__details">
					<div>
						{{ location.address }}</br>
						{{ location.city }}, {{ location.state }} {{ location.zip }}
					</div>
					<div>
						<div class="website"><a v-if="location.website" :href="location.website" target="_blank">Website</a></div>
						<div class="phone" v-if="location.phone">
							<strong>Phone:</strong> <a :href="'tel:' + location.phone">{{ location.phone }}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="logos flex flex-wrap gap-[20px] pt-[18px] px-[15px]">
			<div class="logo__group flex space-x-[15px]">
				<img class="hidden sm:block" src="/images/front/logo-1.png" alt="boat-logo">
				<div class="description">
					<div class="text-[15px] font-semibold">NauticGuard</div>
					<div class="text-[12px]">Boat Warranty <span class="text-orange-brand">*</span></div>
				</div>
			</div>
		</div>
		<showroom-modal v-model="visiting" :boat="inventory"></showroom-modal>
		<boat-call-modal v-model="calling" :boat="inventory"></boat-call-modal>
	</div>
</template>

<script>
	export default {
		props: ['inventory'],
		data() {
			return {
				visiting: false,
				calling: false
			};
		},
		computed: {
			location() {
				return this.$store.state.location;
			},
			exterior_image() {
				if(!this.inventory || !this.inventory.exterior_color || !this.inventory.exterior_color.image) {
					return '';
				}
				return this.inventory.exterior_color.image.thumb100;
			},
			interior_image() {
				if(!this.inventory || !this.inventory.interior_color || !this.inventory.interior_color.image) {
					return '';
				}
				return this.inventory.interior_color.image.thumb100;
			}
		}
	}
</script>